import { useTranslation } from "react-i18next";
import { ConfigSwitch } from "../../../../athlete-portal/profile/components/ClientConfiguration/ConfigSwitch";
import { SectionLabel } from "./SectionLabel";
import type { PushDashboardFormState } from "./utils";

type OptionKey = "quickLog" | "floatingLog" | "dailyGoals";

const OPTIONS: { key: OptionKey; needsMetric: boolean }[] = [
  { key: "quickLog", needsMetric: true },
  { key: "floatingLog", needsMetric: true },
  { key: "dailyGoals", needsMetric: false },
];

export const DashboardOptionsCard = ({
  state,
  canLog,
  onChange,
}: {
  state: PushDashboardFormState;
  canLog: boolean;
  onChange: (key: OptionKey, value: boolean) => void;
}) => {
  const { t } = useTranslation("dashboard");

  return (
    <>
      <SectionLabel label={t("pushDailyDashboard.dashboardOptions")} />
      <div className="push-dd-grid">
        {OPTIONS.map(({ key, needsMetric }) => {
          const locked = needsMetric && !canLog;
          const title = t(`pushDailyDashboard.options.${key}.title`);
          return (
            <div
              key={key}
              className={`push-dd-tile push-dd-option${locked ? " is-locked" : ""}`}
            >
              <div className="push-dd-tile__text">
                <p className="push-dd-tile__title">{title}</p>
                <p className="push-dd-tile__sub">
                  {locked
                    ? t("pushDailyDashboard.options.needsMetric")
                    : t(`pushDailyDashboard.options.${key}.description`)}
                </p>
              </div>
              <ConfigSwitch
                id={`push-dd-option-${key}`}
                ariaLabel={title}
                checked={needsMetric ? state[key] && canLog : state[key]}
                disabled={locked}
                onChange={(value: boolean) => onChange(key, value)}
              />
            </div>
          );
        })}
      </div>
    </>
  );
};
